import { useTranslation } from 'react-i18next'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import { Container } from 'js/components/Grid'
import PageHeader from 'js/components/PageHeader/PageHeader'
import Section from 'js/components/Section/Section'

import Card from './components/Card'
import WikiList from './containers/WikiList'

const List = () => {
    const { data } = useQuery<any>(GET_WIKI_WRAPPER)
    const { viewer } = data || {}
    const { t } = useTranslation()

    useWindowScrollPosition('wiki')

    return (
        <>
            <PageHeader
                title={t('entity-wiki.name', { count: 2 })}
                canCreate={viewer?.canWriteToContainer}
                createLink="/wiki/add"
                createLabel={t('entity-wiki.create')}
            />
            <Section>
                <Container size="tiny">
                    <WikiList
                        subtype="wiki"
                        containerGuid="1"
                        childComponent={Card}
                        offset={0}
                        limit={20}
                    />
                </Container>
            </Section>
        </>
    )
}

const GET_WIKI_WRAPPER = gql`
    query WikiWrapper {
        viewer {
            guid
            loggedIn
            canWriteToContainer(subtype: "wiki")
        }
    }
`

export default List
